module.exports = __webpack_public_path__ + "img/icon-arrows-up.78952d2b.svg";